export const language = {
  en: {
    "Click or drag the file here to upload": "Click or drag the file here to upload",
    "Extensions are supported: jpg, jpeg, png, word, excel, ppt, pdf, rar, zip, txt, flv, rmvb, mvb and mp4": "Extensions are supported: jpg, jpeg, png, word, excel, ppt, pdf, rar, zip, txt, flv, rmvb, mvb and mp4",
  },
  zh: {
    "Click or drag the file here to upload": "点击或将文件拖拽到这里上传",
    "Extensions are supported: jpg, jpeg, png, word, excel, ppt, pdf, rar, zip, txt, flv, rmvb, mvb and mp4": "支持扩展名:jpg、jpeg、png、word、excel、ppt、pdf、rar、zip、txt、flv、rmvb、mvb、mp4",
  },
};
